<template>
  <v-container>
    <v-row>
      <v-col>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <v-text-field
            v-model="inputName"
            v-on:input="emitInputChange('name', inputName)"
            label="Nome"
            required
          ></v-text-field>
          
          <v-text-field
            v-model="inputEmail"
            v-on:input="emitInputChange('email', inputEmail)"
            label="E-mail"
            required
          ></v-text-field>

          <v-text-field
            v-model="inputTelephone"
            v-on:input="emitInputChange('telephone', inputTelephone)"
            label="Telefone"
            required
            v-mask="['(##) ####-####', '(##) #####-####']"
          ></v-text-field>

          <v-select
            v-model="inputCargo"
            :items="itemsCargo"
            v-on:input="emitInputChange('cargo', inputCargo)"
            label="Cargo"
            required
          ></v-select>

          <v-text-field
            v-model="inputCompanyName"
            v-on:input="emitInputChange('companyName', inputCompanyName)"
            label="Empresa"
            required
          ></v-text-field>

          <v-text-field
            v-model="inputQtdFunc"
            v-on:input="emitInputChange('qtdFunc', inputQtdFunc)"
            type="number"
            label="Quantidade de funcionários"
            required
          ></v-text-field>

          <v-text-field
            v-model="inputQtdVend"
            v-on:input="emitInputChange('qtdVend', inputQtdVend)"
            type="number"
            label="Quantidade de vendedores"
            required
          ></v-text-field>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask';
export default {
  components: {},
  directives: { mask },
  data: function() {
    return {
      inputName: '',
      inputEmail: '',
      inputTelephone: '',
      inputCargo: '',
      inputCompanyName: '',
      inputQtdFunc: '',
      inputQtdVend: '',
      formValid: false,

      itemsCargo: [
        { text: 'Sócio / Diretor Comercial', value: 'socioDiretor' },
        { text: 'Gerente de Vendas', value: 'gerente' },
        { text: 'Vendedor / Consultor', value: 'vendedor' },
        { text: 'Outro', value: 'outro' }
      ]
    };
  },
  props: {
    test: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    emitInputChange(fieldName, value) {
      this.$emit('input-change', fieldName, value);
    }
  }
};
</script>

<style>
</style>